import React from "react";
import { useSelector } from "react-redux";
import useLanguageChange from "../../hooks/useLanguageChange";
import CenterModal from "../UI/Modal/CenterModal";

const PrepareRecordingView = () => {
    const localisedValues = useLanguageChange();
    const { recordInProcess } = useSelector((state) => state.recording);

    const body = (
        <div className='start-recording-box' data-testid='prepare-recording-view'>
            <div className='start-recording-loader'>
                <div className='round-loader'></div>
            </div>
            <div className='start-recording-text'>
                <p>{localisedValues?.wait_for_recording}</p>
            </div>
        </div>
    );

    return (
        <CenterModal
            showModal={recordInProcess}
            modalClass='default-modal modal-small start-recording-modal'
            className='modal-dialog-centered'
            body={body}
            backdrop={"static"}
            keyboard={false}
        />
    );
};

export default PrepareRecordingView;
